export default {
  text: 'Öffnen {{paymentGateway}} Profil',
  text_generic: 'Onboarding-Profil öffnen',
  toasts: {
    failed_to_create: '{{paymentGateway}}-Profil konnte nicht geöffnet werden',
    link_copied: 'Link in die Zwischenablage kopiert',
    copy_failed: 'Link konnte nicht kopiert werden',
  },
};
